import { Page, Card, BlockStack, Text, Link as PolarisLink } from '@shopify/polaris';
import { Link } from 'react-router-dom';

interface NavLink {
  label: string;
  to: string;
  description: string;
}

const LINKS: NavLink[] = [
  {
    label: 'Shipping rates',
    to: '/admin/carrier-control/shipping-rates',
    description: 'Manual rates — free baths/showers, configurable consumables (TNT stood down)',
  },
  {
    label: 'Consignments',
    to: '/admin/carrier-control/consignments',
    description: 'Browse TNT consignments and tracking history',
  },
  {
    label: 'Fallback rates',
    to: '/admin/carrier-control/fallback-rates',
    description: 'Manage rates used when TNT is unreachable',
  },
  {
    label: 'TNT settings',
    to: '/admin/carrier-control/tnt-settings',
    description: 'View TNT credentials and test the connection',
  },
  {
    label: 'Tracking log',
    to: '/admin/carrier-control/tracking-log',
    description: 'All tracking events received from TNT',
  },
  {
    label: 'Webhook log',
    to: '/admin/carrier-control/webhook-log',
    description: 'Shopify webhook delivery audit log',
  },
  {
    label: 'CarrierService',
    to: '/admin/carrier-control/carrier-service',
    description: 'Register the live-rate carrier with Shopify',
  },
];

export function CarrierControlIndex(): JSX.Element {
  return (
    <Page title="Carrier control" subtitle="Fjord TNT integration admin">
      <BlockStack gap="300">
        {LINKS.map((link) => (
          <Card key={link.to}>
            <BlockStack gap="100">
              <PolarisLink url={link.to} monochrome={false}>
                <Link to={link.to}>
                  <Text as="h3" variant="headingSm">{link.label}</Text>
                </Link>
              </PolarisLink>
              <Text as="p" variant="bodyMd" tone="subdued">
                {link.description}
              </Text>
            </BlockStack>
          </Card>
        ))}
      </BlockStack>
    </Page>
  );
}
